// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{
    key: string;
    value: string | any[] | undefined;
}>;

export const DispatchSetFieldValue: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/RecommendedProductRequestForm/SetFieldValue",
        key: props.parameter.key,
        value: props.parameter.value,
    });
};

export const chain = [DispatchSetFieldValue];

const setFieldValue = createHandlerChainRunner(chain, "SetFieldValue");
export default setFieldValue;
